import { Badge } from '../ui/badge';
import { FileText, Clock, AlertCircle, CheckCircle, Upload, Eye } from 'lucide-react';

export const TaxReturnStatusBadge = ({ status, className = '' }) => {
  const statusConfig = {
    not_started: {
      className: 'bg-muted text-foreground border-border',
      icon: Clock,
      label: 'Not Started'
    },
    in_progress: {
      className: 'bg-blue-100 text-blue-800 border-blue-200',
      icon: FileText,
      label: 'In Progress'
    },
    awaiting_documents: {
      className: 'bg-amber-100 text-amber-800 border-amber-200',
      icon: Upload,
      label: 'Awaiting Documents'
    },
    under_review: {
      className: 'bg-purple-100 text-purple-800 border-purple-200',
      icon: Eye,
      label: 'Under Review'
    },
    ready_for_xero: {
      className: 'bg-green-100 text-green-800 border-green-200',
      icon: CheckCircle,
      label: 'Ready for Xero'
    },
    completed: {
      className: 'bg-green-100 text-green-800 border-green-200',
      icon: CheckCircle,
      label: 'Completed'
    }
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.not_started;
  const Icon = config.icon;

  return (
    <Badge 
      className={`flex items-center gap-1.5 ${config.className} ${className}`}
      data-testid={`tax-status-badge-${status?.toLowerCase()}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {config.label}
    </Badge>
  );
};